var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xpHolder"},_vm._l((_vm.xps),function(xp,i){return _c('xp-item',{key:i,attrs:{"item":xp}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }